"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listReportDefinitions = exports.generateReport = void 0;
const abortable_fetch_1 = require("../../utils/abortable-fetch");
function generateReport(url, code, input) {
    return abortable_fetch_1.abortableFetch(`${url}/${code}/generate`, {
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        method: 'POST',
        body: JSON.stringify(input),
    });
}
exports.generateReport = generateReport;
function listReportDefinitions(url) {
    return abortable_fetch_1.abortableFetch(`${url}/definitions`, {
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        method: 'POST',
    });
}
exports.listReportDefinitions = listReportDefinitions;
//# sourceMappingURL=reporting-api.js.map